import { Article } from '../../Article';
import { ArticleColorPersistenceMapper } from './ArticleColorPersistenceMapper';

export class ArticlePersistenceMapper {
  public static toDto = (article: Article): SimpleProjectServiceAPI.ArticleDto => ({
    id: article.id,
    number: article.number,
    colors: article.colors.map(ArticleColorPersistenceMapper.toDto),
    requiredConnectArticleId: article.requiredConnectArticleId,
    requiredLightingArticlesIds: article.requiredLightingArticlesIds,
    model3dName: article.customModelName
      ? article.customModelName
      : article.definition?.model3d?.name,
  });

  public static toDomain = (dto: SimpleProjectServiceAPI.ArticleDto): Article => ({
    id: dto.id,
    number: dto.number,
    colors: dto.colors.map(ArticleColorPersistenceMapper.toDomain),
    requiredConnectArticleId: dto.requiredConnectArticleId,
    requiredLightingArticlesIds: dto.requiredLightingArticlesIds,
    definition: undefined,
    customModelName: dto.model3dName,
  });
}
